/*
 * ⚠️ [amended P5b] THE STORE MOVED TO `@pams/client-core/auth`. THIS FILE IS THE DASHBOARD'S
 *  ONE INSTANCE OF IT, AND IT OWNS THE TWO KEY NAMES.
 *
 * Read `packages/client-core/src/auth/tokenStore.ts`'s header first — the no-cookies
 * decision, its cost, and the compensating controls are all recorded there and none of them
 * changed. Two things are worth knowing HERE:
 *
 *  1. `pams.at` / `pams.rt` ARE THE DASHBOARD'S KEYS AND NOTHING ELSE MAY TAKE THEM. They
 *     are asserted literally in `lib/api.test.ts` and seeded literally by
 *     `e2e/fixtures/session.ts`. The officer PWA holds a `pams:officer` token, which is a
 *     different audience: sharing a slot would have the API answer `403 WRONG_SURFACE`
 *     while the client refreshed a perfectly valid token for ever. It takes `pams.app.*`.
 *
 *  2. THERE IS EXACTLY ONE STORE PER APP, and it is created here. The state inside it is a
 *     memory mirror; two instances mean two mirrors and a refresh storm the server
 *     correctly reads as token reuse.
 */
import { createTokenStore } from '@pams/client-core/auth';

const store = createTokenStore({ accessKey: 'pams.at', refreshKey: 'pams.rt' });

export const getAccessToken = store.getAccessToken;
export const getRefreshToken = store.getRefreshToken;
export const setTokens = store.setTokens;
export const clearTokens = store.clearTokens;

/** The instance itself, for `lib/api.ts` — nothing else needs it. */
export const dashboardTokenStore = store;
